import React from 'react'
import { Helmet } from 'react-helmet'

const Meta = ({ title, description, keywords,script }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description} />
      <meta name='keyword' content={keywords} />
      <script>
        {script}
      </script>
    </Helmet>
  )
}

Meta.defaultProps = {
  title: 'EFA Aylink ',
  description: 'EFA Aylink, gala dinner',
  keywords: 'EFA Aylink, gala dinner , marrakech',
}

export default Meta
